import DashboardLayout from '@/layouts/DashboardLayout.vue';
import DefaultLayout from '@/layouts/DefaultLayout.vue';
import auth from '@/middleware/auth';
import type { Middleware } from '@/types/router';
import { LivestreamRouteName } from '@/types/router/name/livestreams';
import { LivestreamRoutePath } from '@/types/router/path/livestreams';

export default [
    {
        path: LivestreamRoutePath.Livestreams,
        name: LivestreamRouteName.Livestreams,
        component: () => import('@/pages/livestreams/index.vue'),
        meta: {
            group: 'livestreams',
            title: 'Livestreams',
            layout: DashboardLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: LivestreamRoutePath.Detail,
        name: LivestreamRouteName.Detail,
        component: () => import('@/pages/livestreams/detail/index.vue'),
        meta: {
            group: 'livestreams-detail',
            title: 'Detail Livestreams',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: LivestreamRoutePath.Join,
        name: LivestreamRouteName.Join,
        component: () => import('@/pages/livestreams/join/index.vue'),
        meta: {
            group: 'livestreams-join',
            title: 'Join Livestreams',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: LivestreamRoutePath.Create,
        name: LivestreamRouteName.Create,
        component: () => import('@/pages/livestreams/create/index.vue'),
        meta: {
            group: 'livestreams-create',
            title: 'Create Livestreams',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: LivestreamRoutePath.Edit,
        name: LivestreamRouteName.Edit,
        component: () => import('@/pages/livestreams/edit/index.vue'),
        meta: {
            group: 'livestreams-edit',
            title: 'Edit Livestreams',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    },
    {
        path: LivestreamRoutePath.Summary,
        name: LivestreamRouteName.Summary,
        component: () => import('@/pages/livestreams/summary/index.vue'),
        meta: {
            group: 'livestreams-summary',
            title: 'Summary Livestreams',
            layout: DefaultLayout,
            middleware: [auth] as Middleware[]
        }
    }
];
